import React from "react";
import { formatKitchenDelay } from "../../tableServingTiming";
import "./ServingTimingBadge.css";

const clockIcon = (
  <svg
    className="ts-serving-timing-badge__clock"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="8" cy="8" r="6" />
    <path d="M8 4.5V8l2.25 1.4" />
  </svg>
);

const ServingTimingBadge = ({ summary }) => {
  if (!summary) return null;

  const allowedTones = ["green", "orange", "red", "neutral"];
  const tone = allowedTones.includes(summary.tone) ? summary.tone : "neutral";
  const label = summary.label || "Timing unavailable";
  const display = typeof summary.display === "string" ? summary.display : "";
  const displayText = tone === "red" ? formatKitchenDelay(display) : display;
  const delayedOrders = Number.isFinite(Number(summary.delayedOrders))
    ? Number(summary.delayedOrders)
    : 0;
  const orderCount = Number.isFinite(Number(summary.orderCount))
    ? Number(summary.orderCount)
    : 0;
  const unknownOrders = Number.isFinite(Number(summary.unknownOrders))
    ? Number(summary.unknownOrders)
    : 0;
  const description = summary.description || "Kitchen timing is unavailable.";
  const timeMeaning = display
    ? tone === "red"
      ? displayText
      : `${display} (minutes:seconds)`
    : "";
  const accessibleSummary = [
    `${label}${timeMeaning ? `, ${timeMeaning}` : ""}.`,
    description,
    ...(summary.orderCount != null ? [`${delayedOrders} delayed of ${orderCount} orders; ${unknownOrders} with unknown timing.`] : []),
  ].join(" ");

  return (
    <span
      className={`ts-serving-timing-badge ts-serving-timing-badge--${tone}`}
      title={accessibleSummary}
      role="img"
      aria-label={accessibleSummary}
    >
      {clockIcon}
      <span className="ts-serving-timing-badge__text">
        <span className="ts-serving-timing-badge__label">{label}</span>
        {display && (
          <span className="ts-serving-timing-badge__display">{displayText}</span>
        )}
      </span>
    </span>
  );
};

export default ServingTimingBadge;
